import { createContext, useContext, useState, ReactNode } from "react";
import { GlobalMovement } from "../types";

interface HistoryContextType {
  movements: GlobalMovement[];
  addMovement: (movement: Omit<GlobalMovement, "id" | "timestamp">) => void;
}

const HistoryContext = createContext<HistoryContextType | undefined>(undefined);

export function HistoryProvider({ children }: { children: ReactNode }) {
  const [movements, setMovements] = useState<GlobalMovement[]>([]);

  const addMovement = (movement: Omit<GlobalMovement, "id" | "timestamp">) => {
    const newMovement: GlobalMovement = {
      ...movement,
      id: `MOV-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date(),
    };
    setMovements((prev) => [newMovement, ...prev]);
  };

  return (
    <HistoryContext.Provider value={{ movements, addMovement }}>
      {children}
    </HistoryContext.Provider>
  );
}

export function useHistory() {
  const context = useContext(HistoryContext);
  if (!context) {
    throw new Error("useHistory must be used within a HistoryProvider");
  }
  return context;
}
